var Utils = require("./utils");
var queryArray = Utils.queryArray;

var bgCategoryLinks = queryArray("li.category a");

bgCategoryLinks.forEach(function(item) {
  item.addEventListener("click", function() {
    var bgCategory = item.parentElement;
    if (bgCategory.classList.contains("active"))
      bgCategory.classList.remove("active");
    else
      bgCategory.classList.add("active");
  });
});